import TimePicker from 'antd/lib/time-picker'
import type { TimePickerProps as AntdTimePickerProps } from 'antd/lib/time-picker'
import { connectReadonlyComponent } from '../connect'
import { PreviewText } from '../preview-text'

import 'antd/lib/time-picker/style'

export * from 'antd/lib/time-picker'

export type TimePickerProps = AntdTimePickerProps & {
  readonly?: boolean
}

export default connectReadonlyComponent(TimePicker, PreviewText.TimePicker)
